import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { Button, type ButtonProps } from './Button';

type PopoverTriggerButtonProps = ButtonProps & {
  isEmpty: boolean;
  isOpen: boolean;
};

export const PopoverTriggerButton = ({ children, isEmpty, sx, isOpen, ...rest }: PopoverTriggerButtonProps) => {
  return (
    <Button
      color="secondary"
      variant="text"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        border: '1px solid transparent',
        ...(!isEmpty && {
          backgroundColor: 'primary.light',
          color: 'primary.main',
          '&:hover': {
            backgroundColor: 'primary.light',
            borderColor: 'primary.main',
          },
        }),
        ...sx,
      }}
      {...rest}
    >
      {children}
      <KeyboardArrowDown
        data-test="popover-trigger-button-arrow"
        sx={{
          transition: 'transform 0.2s ease-in-out',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
      />
    </Button>
  );
};
